import { render, staticRenderFns } from "./envelope-recipients.vue?vue&type=template&id=137f33d4"
import script from "./envelope-recipients.vue?vue&type=script&lang=js"
export * from "./envelope-recipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports